import { FC } from 'react';
import { z } from 'zod';
import { OpportunityDrawerForm } from './OpportunityDrawerForm';
import { OpportunityDrawerTabs } from './OpportunityDrawerTabs';
import { DrawerWrapper } from '../../../../../drawer/DrawerWrapper';

export const opportunityEditDrawerSchema = z.object({
	opportunityId: z.string(),
	activityId: z.string(),
});

export const OpportunityEditDrawer: FC<z.infer<typeof opportunityEditDrawerSchema>> = ({ opportunityId, activityId }) => {
	return (
		<DrawerWrapper sx={{ overflowY: 'auto', alignItems: 'stretch' }}>
			<OpportunityDrawerForm opportunityId={opportunityId} />
			<OpportunityDrawerTabs opportunityId={opportunityId} activityId={activityId} />
		</DrawerWrapper>
	);
};
